import React from 'react'
import { Flex } from '@components'
import { Form, Button, Input } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { message } from 'antd/lib/index'
import NHFetch from '../../../../utils/NHFetch'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { getLoginUser } from '@utils/NHCore'
import CommonTip from '../common'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'
import moment from 'moment'

const FormItem = Form.Item
const basicUrl = 'api/zhxg-yxwz'

const BLOCK_TIP_MSG = {
  cnsNotCompleted: '需完成住宿承诺书签署方可进行入住提交',
  timeExpired: '已错过住宿申请时间',
}

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 10 }
}

@Form.create()
export default class ConfirmCheckIn extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      xsid: getLoginUser().userId,
      zzbdhjid: this.getUrlParams('pkid'),
      mkbz: 'GD041_11',
      hjmc: '入住提交',
      editable: false,
      nextUrl: '',
      search: '',
      operable: true,
      nonOperationalData: {},
      blockTip: null,
      xssfytj: '',
      formData: {},
      isRender: false,
    }
  }

  componentDidMount() {
    this.queryQztjAndYlhj()
  }

  isTimeExpired = (kfsj) => {
    if (!kfsj || !kfsj.JSSJ) {
      return false
    }
    return moment().isAfter(moment(kfsj.JSSJ, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm']))
  }

  queryQztjAndYlhj = () => {
    const { zzbdhjid } = this.state
    let xsid = getLoginUser() ? getLoginUser().userId : ''
    if (!xsid) {
      this.setState({
        nonOperationalData: { nologin: true },
        operable: false
      })
      return
    }
    NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid }).then(res => {
      if (res && res.data) {
        let kfsj = res.data['kfsj']
        let ylhj = res.data['ylhj']
        let qzhj = res.data['qzhj']
        let nohj = res.data['nohj']
        let operable = true
        let blockTip = null
        if (kfsj && kfsj['YXSJ'] != '1') {
          operable = false
          if (this.isTimeExpired(kfsj)) {
            blockTip = 'timeExpired'
          }
        }
        if (ylhj && ylhj.length > 0) {
          operable = false
        }
        if (qzhj && qzhj.length > 0) {
          operable = false
        }
        if (nohj) {
          operable = false
        }
        this.setState({ nonOperationalData: res.data, operable, blockTip }, () => {
          if (operable) {
            this.getRzsqQrPz()
          } else if (blockTip === 'timeExpired') {
            this.setState({ isRender: true })
          }
        })
      }
    })
  }

  setMenuList = menuList => {
    let nextCount = 0
    let bz = this.state.mkbz
    menuList.map((elem, index) => {
      if (elem.HJDM == bz) {
        let hjmc = elem.HJMC
        this.setState({ hjmc: hjmc })
        nextCount = index + 1
        return
      }
    })
    let menu = menuList[nextCount]
    if (menu) {
      let hjdm = menu.HJDM
      if (hjdm.indexOf('GD') == 0) {
        let gdUrl = mkbz[hjdm]
        this.setState({
          nextUrl: gdUrl,
          search: 'pkid=' + menu.PKID
        })
      } else if (hjdm.indexOf('ZDY') == 0) {
        let zdyUrl = '/customLink'
        this.setState({
          nextUrl: zdyUrl,
          search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
        })
      }
    } else {
      this.setState({
        nextUrl: '',
        search: ''
      })
    }
  }

  getUrlParams = param => {
    return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
  }

  reloadMenu = () => {
    this.refs.siderMenu.reloadMenuList()
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.saveXsRzsqQr(values)
    })
  }

  getRzsqQrPz = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/rzsqxx/getRzsqCnsPz?xsid=${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        if (res.data?.xssfytj !== '1') {
          this.setState({ blockTip: 'cnsNotCompleted', isRender: true })
          return
        }
        NHFetch(`${basicUrl}/zzbd/rzsqxx/getRzsqQrPz?xsid=${xsid}`, 'GET').then(qrRes => {
          if (qrRes && qrRes.code === 200) {
            let xssfytj = qrRes.data?.xssfytj ?? '0'
            this.setState({
              blockTip: null,
              xssfytj: xssfytj,
              editable: xssfytj === '0',
            })
            this.getXsRzsqQr()
          }
        })
      }
    })
  }

  saveXsRzsqQr = values => {
    const { xsid, zzbdhjid, formData } = this.state
    const formDataObj = new FormData()
    const token = window.sessionStorage.getItem('access_token')

    if (formData.sfsq === '0') {
      formDataObj.append('jjlxr', values.jjlxr)
      formDataObj.append('lxrdh', values.lxrdh)
    }
    formDataObj.append('zzbdhjid', zzbdhjid)
    formDataObj.append('czpt', '1')

    fetch(`${basicUrl}/zzbd/rzsqxx/saveXsRzsqQr`, {
      method: 'POST',
      headers: { token: token, loginUserId: xsid },
      body: formDataObj
    })
      .then(async response => {
        const res = await response.json()
        if (res && res.code === 200) {
          if (res.data == '1') {
            message.success('信息保存成功！')
            this.getRzsqQrPz()
            this.reloadMenu()
            this.setState({ editable: false })
          } else {
            message.error('信息保存失败，请重试！')
          }
        } else {
          message.error(res?.message || '信息保存失败，请重试！')
        }
      })
      .catch(err => {
        message.error('信息保存失败，请重试！')
      })
  }

  getXsRzsqQr = () => {
    const { xsid } = this.state
    NHFetch(`${basicUrl}/zzbd/rzsqxx/getXsRzsqQr/${xsid}`, 'GET').then(res => {
      if (res && res.code === 200) {
        this.setState({ formData: res.data || {} }, () => {
          this.setState({ isRender: true })
        })
      }
    })
  }

  renderBlockTipContent = () => {
    const { blockTip, nextUrl, search } = this.state
    return (
      <div className="p-sw" style={{ textAlign: 'center', padding: '40px 0' }}>
        <span className="text-info-red">{BLOCK_TIP_MSG[blockTip]}</span>
        <div className="text-center mt-50">
          <NextButton nextUrl={nextUrl} search={search} />
        </div>
      </div>
    )
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { editable, formData, isRender, blockTip, operable } = this.state
    const isOffCampus = formData.sfsq === '0'
    const showForm = isRender && !blockTip && operable

    if (!operable && blockTip === 'timeExpired' && isRender) {
      return (
        <div>
          <Flex className="w1180 mt-20" align="start">
            <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
            <Flex.Item className="page_con_r">
              <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
              <div className="box">
                <Hint />
                <TitleTop title={this.state.hjmc} extra={false} />
                {this.renderBlockTipContent()}
              </div>
            </Flex.Item>
          </Flex>
        </div>
      )
    }

    return (
      <div>
        {operable ? (
          <Flex className="w1180 mt-20" align="start">
            <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到" mkbz={this.state.mkbz} menuType="自助报到" />
            <Flex.Item className="page_con_r">
              <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
              <div className="box">
                <Hint />
                <TitleTop title={this.state.hjmc} extra={false} />
                {blockTip === 'cnsNotCompleted' && isRender && this.renderBlockTipContent()}
                {showForm && (
                  <Form onSubmit={this.handleSubmit}>
                    <div className="p-sw">
                      <FormItem {...formItemLayout} label="是否申请入住">
                        {formData.sfsq === '1' ? '是' : formData.sfsq === '0' ? '否' : '-'}
                      </FormItem>

                      {!isOffCampus && (
                        <FormItem {...formItemLayout} label="提交说明">
                          您已选择申请入住，请确认提交入住申请。
                        </FormItem>
                      )}

                      {isOffCampus && (
                        <React.Fragment>
                          <FormItem {...formItemLayout} label="校外紧急联系人">
                            {editable &&
                              getFieldDecorator('jjlxr', {
                                initialValue: formData.jjlxr,
                                rules: [
                                  {
                                    required: true,
                                    message: '请填写校外紧急联系人'
                                  }
                                ]
                              })(<Input placeholder="请填写校外紧急联系人" />)}
                            {!editable && (formData.jjlxr || '-')}
                          </FormItem>

                          <FormItem {...formItemLayout} label="联系电话">
                            {editable &&
                              getFieldDecorator('lxrdh', {
                                initialValue: formData.lxrdh,
                                rules: [
                                  {
                                    required: true,
                                    message: '请填写联系电话'
                                  }
                                ]
                              })(<Input placeholder="请填写联系电话" />)}
                            {!editable && (formData.lxrdh || '-')}
                          </FormItem>
                        </React.Fragment>
                      )}

                      <div className="text-center mt-50">
                        {editable && (
                          <Button type="primary" htmlType="submit">
                            {isOffCampus ? '提交校外住宿申请' : '提交入住申请'}
                          </Button>
                        )}

                        {!editable && (
                          <Button type="primary" onClick={() => this.setState({ editable: true })}>
                            修改
                          </Button>
                        )}

                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                      </div>
                    </div>
                  </Form>
                )}
              </div>
            </Flex.Item>
          </Flex>
        ) : (
          <CommonTip hjmc={'入住提交'} key={'GD041_11'} mkbz="GD041_11" nonOperationalData={this.state.nonOperationalData} />
        )}
      </div>
    )
  }
}
